<template>
  <v-container
    v-if="access.includes(roles.settings)"
    class="settings"
  >
    <base-material-card>
      <template v-slot:heading>
        <div class="text-h3 font-weight-light">
          {{ store_name }}
        </div>
      </template>
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <v-card>
            <v-card-title
              :class="{[`elevation-2`] : !loading_business_extensions}"
              class="sub-header"
            >
              <!-- Rename Business Extensions to Channels -->
              <div class="primary--text">
                Channels
              </div>
              <v-spacer />
              <v-btn
                small
                color="primary"
                :class="{hidden: business_extensions.length === 0 }"
                @click="SaveBusinessExtension()"
              >
                Save
              </v-btn>
              <v-progress-linear
                color="success"
                :class="{hidden: !loading_business_extensions }"
                indeterminate
              />
            </v-card-title>
            <v-col>
              <v-row>
                <v-col
                  v-for="extension in business_extensions"
                  :key="extension.name"
                  sm="6"
                >
                  <v-checkbox
                    v-model="store_business_extensions"
                    :label="extension.description"
                    :value="extension.name"
                    :readonly="extension.default"
                    :color="extension.default?'green lighten-3':''"
                  >
                    <template v-slot:append="">
                      <v-text-field
                        v-if="extension.name === 'DC' && store_business_extensions.includes('DC')"
                        v-model="desert_center_count"
                        type="number"
                        class="DC_Count"
                        :rules="[
                          () => !!desert_center_count && desert_center_count > 0 || 'Invalid input!' ,
                          () => !!desert_center_count && desert_center_count <= 5 || 'Invalid input!' ,
                        ]"
                      />
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="12"
        >
          <v-card>
            <v-card-title
              :class="{[`elevation-2`] : !loading_dayparts}"
              class="sub-header"
            >
              <div class="primary--text">
                Daypart
              </div>
              <v-spacer />
              <v-btn
                small
                color="primary"
                :class="{ hidden: loading_dayparts }"
                @click="NewDaypart()"
              >
                New
              </v-btn>
              <v-progress-linear
                color="success"
                :class="{hidden: !loading_dayparts }"
                indeterminate
              />
            </v-card-title>
            <v-data-table
              :headers="headers_dayparts"
              :items="dayparts"
              :disable-sort="true"
              :class="{ hidden: loading_dayparts }"
              class="elevation-2 text-no-wrap dense-2"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-tooltip
                    color="success"
                    left
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        dark
                        x-small
                        :disabled="item.name === 'REG'"
                        class="btn-edit"
                        color="cyan"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="EditDaypart(item)"
                      >
                        <v-icon dark>
                          mdi mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Edit Daypart</span>
                  </v-tooltip>
                  <v-tooltip
                    color="success"
                    left
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        dark
                        x-small
                        :disabled="item.name === 'REG'"
                        class="btn-delete ml-2"
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="DeleteDayPart(item)"
                      >
                        <v-icon dark>
                          mdi mdi-close
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Delete Daypart</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="12"
        >
          <v-card>
            <v-card-title
              :class="{[`elevation-2`] : !loading_positioning_guides}"
              class="sub-header"
            >
              <div class="primary--text">
                Positioning Guide
              </div>
              <v-spacer />
              <v-btn
                small
                color="primary"
                :class="{ hidden: loading_positioning_guides }"
                @click="NewPositioningGuide()"
              >
                New
              </v-btn>
              <v-progress-linear
                color="success"
                :class="{hidden: !loading_positioning_guides }"
                indeterminate
              />
            </v-card-title>
            <v-data-table
              :headers="headers_positioning_guides"
              :items="positioning_guides"
              :disable-sort="true"
              :class="{ hidden: loading_positioning_guides }"
              class="elevation-2 text-no-wrap dense-2"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-tooltip
                    color="success"
                    left
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        dark
                        x-small
                        :disabled="item.name === 'REG'"
                        class="btn-edit"
                        color="cyan"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="EditPositioningGuide(item)"
                      >
                        <v-icon dark>
                          mdi mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Edit Positioning Guide</span>
                  </v-tooltip>
                  <v-tooltip
                    color="success"
                    left
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        dark
                        x-small
                        :disabled="item.name === 'REG'"
                        class="btn-delete ml-2"
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="DeletePositioningGuide(item)"
                      >
                        <v-icon dark>
                          mdi mdi-close
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Delete Positioning Guide</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </base-material-card>
    <!-- Alert  -->

    <!-- Daypart input dialog -->
    <v-dialog
      v-model="show_daypart"
      width="40%"
      max-width="40%"
    >
      <v-card>
        <v-card-title class="text-left">
          <h2 class="primary--text">
            {{ daypart_title }}
          </h2>
        </v-card-title>
        <v-card-text>
          <v-col
            cols="12"
          >
            <v-select
              v-model="business_extension"
              label="Channel"
              :items="store_business_extensions"
              :disabled="daypart_disabled"
              :rules="[
                v => !!v || 'This is required'
              ]"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="daypart_name"
              label="Day Part"
              :rules="[
                v => !!v || 'This is required',
                v => !!v && v.length <= 20 || 'Max input of 20 characters only'
              ]"
            />
          </v-col>
          <v-col cols="12">
            <v-range-slider
              v-model="slider"
              label="Time Range :"
              thumb-label="always"
              :thumb-size="38"
              :min="0"
              :max="23"
            >
              <template v-slot:thumb-label="{ value }">
                {{ GetIntToTime(value) }}
              </template>
            </v-range-slider>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            :disabled="in_process"
            @click="SaveDaypart"
          >
            Save
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="in_process"
            @click="show_daypart = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End daypart input dialog -->

    <!-- Positioning guide input dialog -->
    <v-dialog
      v-model="show_positioning_guide"
      width="40%"
      max-width="40%"
    >
      <v-card>
        <v-card-title class="text-left">
          <h2 class="primary--text">
            {{ positioning_guide_title }}
          </h2>
        </v-card-title>
        <v-card-text>
          <v-col
            cols="12"
          >
            <v-select
              v-model="business_extension"
              label="Channel"
              :items="store_business_extensions"
              :disabled="daypart_disabled"
              :rules="[
                v => !!v || 'This is required'
              ]"
            >
              <template v-slot:selection="{ item }">
                <span class="v-select__selection v-select__selection--comma">{{ item }}</span>
                {{ GetDayPartList (item) }}
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
          >
            <v-select
              v-model="daypart_name"
              label="Day Part"
              :items="daypart_list"
              :disabled="daypart_disabled"
              :rules="[
                v => !!v || 'This is required'
              ]"
            />
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="guest_count_from"
                  label="Guest Count From"
                  type="number"
                  :rules="[
                    () => !!guest_count_from && guest_count_from > 0 || 'Invalid input!' ,
                    () => !!guest_count_from && guest_count_from <= 300 || 'Invalid input!' ,
                  ]"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="guest_count_to"
                  label="Guest Count To"
                  type="number"
                  :rules="[
                    () => !!guest_count_to && guest_count_to > 0 || 'Invalid input!' ,
                    () => !!guest_count_to && guest_count_to <= 300 || 'Invalid input!' ,
                  ]"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="crew_count"
              label="Number of Crew"
              type="number"
              :rules="[
                () => !!crew_count && crew_count > 0 || 'Invalid input!' ,
                () => !!crew_count && crew_count <= 100 || 'Invalid input!' ,
              ]"
            />
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            :disabled="in_process"
            @click="SavePositioningGuide"
          >
            Save
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="in_process"
            @click="show_positioning_guide = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Positioning guide input dialog -->
    <confirm ref="confirm" />
  </v-container>
</template>
<script>
  import {
    mapState,
  } from 'vuex'
  import {
    GetStoreBusinessExtensions,
    UpdateStoreBusinessExtension,
  } from '@/graphql/BusinessExtension.gql'
  import {
    GetDayParts,
    GetDayPartList,
    CreateDayPart,
    DeleteDayPart,
    UpdateDayPart,
  } from '@/graphql/DayPart.gql'
  import {
    CreatePositioningGuide,
    UpdatePositioningGuide,
    DeletePositioningGuide,
    GetPositioningGuides,
  } from '@/graphql/PositioningGuide.gql'
  export default {
    components: {
      Confirm: () => import('@/views/dashboard/component/Confirm'),
    },
    data () {
      return {
        // rebuild
        store_name: "McDonald's",
        business_extensions: [],
        store_business_extensions: [],
        store_business_extension_daypart: [],
        dayparts: [],
        positioning_guides: [],
        desert_center_count: 0,
        loading_business_extensions: true,
        loading_dayparts: true,
        loading_positioning_guides: true,
        skip_business_extensions: true,
        skip_dayparts: true,
        skip_positioning_guides: true,
        show_daypart: false,
        daypart_id: '',
        daypart_hash: '',
        daypart_name: '',
        daypart_disabled: false,
        daypart_title: 'New Daypart',
        daypart_list: [],
        loading_daypart_list: false,
        skip_daypart_list: true,
        show_positioning_guide: false,
        positioning_guide_id: '',
        positioning_guide_hash: '',
        positioning_guide_title: 'New Positioning Guide',
        business_extension_filter: '',
        slider: [0, 23],
        business_extension: '',
        guest_count_from: 0,
        guest_count_to: 0,
        crew_count: 0,
        headers_dayparts: [
          { text: 'Channel', value: 'business_extension', class: 'title' },
          { text: 'Day Part', value: 'name', class: 'title' },
          { text: 'Hour From', value: 'hour_from', class: 'title' },
          { text: 'Hour To', value: 'hour_to', class: 'title' },
          { text: 'Actions', value: 'actions', class: 'text-center title' },
        ],
        headers_positioning_guides: [
          { text: 'Channel', value: 'business_extension', class: 'title' },
          { text: 'Day Part', value: 'day_part', class: 'title' },
          { text: 'Guest Count From', value: 'guest_count_from', class: 'title' },
          { text: 'Guest Count To', value: 'guest_count_to', class: 'title' },
          { text: 'Number of Crew', value: 'crew_count', class: 'title' },
          { text: 'Actions', value: 'actions', class: 'title' },
        ],
      }
    },
    computed: {
      ...mapState(['in_process', 'default_error', 'access', 'roles']),
    },
    mounted () {
      window.scrollTo(0, 0)
      this.GetStoreBusinessExtensions()
      this.GetDayParts()
      this.GetPositioningGuides()
    },
    methods: {
      NewDaypart () {
        if (!this.access.includes(this.roles.settings_update)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.daypart_id = ''
        this.daypart_title = 'New Daypart'
        this.daypart_disabled = false
        this.business_extension = ''
        this.daypart_name = ''
        this.slider = [0, 23]
        this.show_daypart = true
      },
      SaveDaypart () {
        if (!this.access.includes(this.roles.settings_update)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        if (this.business_extension === '') {
          // this.$store.commit('ShowError', 'Input missing!')
          return
        }
        if (this.daypart_name === '') {
          // this.$store.commit('ShowError', 'Input missing!')
          return
        }
        this.$store.commit('Notify', '')
        if (this.daypart_id === '') { // new daypart
          this.$apollo.mutate({
            mutation: CreateDayPart,
            variables: {
              input: {
                name: this.daypart_name,
                business_extension: this.business_extension,
                hour_from: this.GetIntToTime(this.slider[0]),
                hour_to: this.GetIntToTime(this.slider[1]),
              },
            },
          }).then((res) => {
            if (res.data) {
              if (res.data.CreateDayPart.status === 'Ok') {
                this.$store.commit('CloseAlert', 'Item has been added successfully!')
                this.dayparts = res.data.CreateDayPart.data
                this.daypart_hash = res.data.CreateDayPart.hash
                this.show_daypart = false
              } else if (res.data.CreateDayPart.status === '0') {
                this.CheckError({ message: 'Session expired!' })
              } else {
                this.$store.commit('ShowError', res.data.CreateDayPart.status)
              }
            }
          }).catch(error => {
            this.CheckError(error)
          })
        } else { // update daypart
          this.$apollo.mutate({
            mutation: UpdateDayPart,
            variables: {
              input: {
                uid: this.daypart_id,
                hash: this.daypart_hash,
                name: this.daypart_name,
                hour_from: this.GetIntToTime(this.slider[0]),
                hour_to: this.GetIntToTime(this.slider[1]),
              },
            },
          }).then((res) => {
            if (res.data) {
              if (res.data.UpdateDayPart.status === 'Ok') {
                this.$store.commit('CloseAlert', 'Changes has been saved!')
                this.dayparts = res.data.UpdateDayPart.data
                this.daypart_hash = res.data.UpdateDayPart.hash
                this.show_daypart = false
                this.GetPositioningGuides()
              } else if (res.data.UpdateDayPart.status === '0') {
                this.CheckError({ message: 'Session expired!' })
              } else {
                this.$store.commit('ShowError', res.data.UpdateDayPart.status)
              }
            }
          }).catch(error => {
            this.CheckError(error)
          })
        }
      },
      EditDaypart (item) {
        if (!this.access.includes(this.roles.settings_update)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.daypart_id = item.uid
        this.daypart_title = 'Edit Daypart'
        this.business_extension = item.business_extension
        this.daypart_disabled = true
        this.daypart_name = item.name
        this.slider = [this.GetTimeToInt(item.hour_from), this.GetTimeToInt(item.hour_to)]
        this.show_daypart = true
      },
      DeleteDayPart (item) {
        if (!this.access.includes(this.roles.settings_update)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.$refs.confirm.open('Please Confirm!', 'You are going to delete this item!', { color: 'red' })
          .then((confirm) => {
            if (confirm) {
              this.$store.commit('Notify', 'Deleting item...')
              this.$apollo.mutate({
                mutation: DeleteDayPart,
                variables: {
                  uid: item.uid,
                  hash: this.daypart_hash,
                },
              }).then((res) => {
                if (res.data) {
                  if (res.data.DeleteDayPart.status === 'Ok') {
                    this.$store.commit('CloseAlert', 'Item has been deleted!')
                    this.dayparts = res.data.DeleteDayPart.data
                    this.daypart_hash = res.data.DeleteDayPart.hash
                    this.GetPositioningGuides()
                  } else if (res.data.DeleteDayPart.status === '0') {
                    this.CheckError({ message: 'Session expired!' })
                  } else {
                    this.$store.commit('ShowError', res.data.DeleteDayPart.status)
                  }
                }
              }).catch(error => {
                this.CheckError(error)
              })
            }
          })
      },
      NewPositioningGuide () {
        if (!this.access.includes(this.roles.settings_update)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.positioning_guide_id = ''
        this.positioning_guide_title = 'New Positioning Guide'
        this.daypart_disabled = false
        this.business_extension = ''
        this.business_extension_filter = ''
        this.daypart_name = ''
        this.daypart_list = []
        this.guest_count_from = 0
        this.guest_count_to = 0
        this.crew_count = 0
        this.show_positioning_guide = true
      },
      SavePositioningGuide () {
        if (!this.access.includes(this.roles.settings_update)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        if (this.business_extension === '') {
          // this.$store.commit('ShowError', 'Input missing!')
          return
        }
        if (this.daypart_name === '') {
          // this.$store.commit('ShowError', 'Input missing!')
          return
        }
        this.$store.commit('Notify', '')
        if (this.positioning_guide_id === '') { // new positioning guide
          this.$apollo.mutate({
            mutation: CreatePositioningGuide,
            variables: {
              input: {
                day_part: this.daypart_name,
                business_extension: this.business_extension,
                guest_count_from: this.guest_count_from,
                guest_count_to: this.guest_count_to,
                crew_count: this.crew_count,
              },
            },
          }).then((res) => {
            if (res.data) {
              if (res.data.CreatePositioningGuide.status === 'Ok') {
                this.$store.commit('CloseAlert', 'Item has been added successfully!')
                this.positioning_guides = res.data.CreatePositioningGuide.data
                this.positioning_guide_hash = res.data.CreatePositioningGuide.hash
                this.show_positioning_guide = false
              } else if (res.data.CreatePositioningGuide.status === '0') {
                this.CheckError({ message: 'Session expired!' })
              } else {
                this.$store.commit('ShowError', res.data.CreatePositioningGuide.status)
              }
            }
          }).catch(error => {
            this.CheckError(error)
          })
        } else { // update positioning guide
          this.$apollo.mutate({
            mutation: UpdatePositioningGuide,
            variables: {
              input: {
                uid: this.positioning_guide_id,
                hash: this.positioning_guide_hash,
                day_part: this.daypart_name,
                business_extension: this.business_extension,
                guest_count_from: this.guest_count_from,
                guest_count_to: this.guest_count_to,
                crew_count: this.crew_count,
              },
            },
          }).then((res) => {
            if (res.data) {
              if (res.data.UpdatePositioningGuide.status === 'Ok') {
                this.$store.commit('CloseAlert', 'Changes has been saved!')
                this.positioning_guides = res.data.UpdatePositioningGuide.data
                this.positioning_guide_hash = res.data.UpdatePositioningGuide.hash
                this.show_positioning_guide = false
              } else if (res.data.UpdatePositioningGuide.status === '0') {
                this.CheckError({ message: 'Session expired!' })
              } else {
                this.$store.commit('ShowError', res.data.UpdatePositioningGuide.status)
              }
            }
          }).catch(error => {
            this.CheckError(error)
          })
        }
      },
      EditPositioningGuide (item) {
        if (!this.access.includes(this.roles.settings_update)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.positioning_guide_id = item.uid
        this.positioning_guide_title = 'Edit Positioning Guide'
        this.business_extension = item.business_extension
        this.daypart_list = [item.day_part]
        this.daypart_name = item.day_part
        this.daypart_disabled = true
        this.guest_count_from = item.guest_count_from
        this.guest_count_to = item.guest_count_to
        this.crew_count = item.crew_count
        this.show_positioning_guide = true
      },
      DeletePositioningGuide (item) {
        if (!this.access.includes(this.roles.settings_update)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.$refs.confirm.open('Please Confirm!', 'You are going to delete this item!', { color: 'red' })
          .then((confirm) => {
            if (confirm) {
              this.$store.commit('Notify', 'Deleting item...')
              this.$apollo.mutate({
                mutation: DeletePositioningGuide,
                variables: {
                  uid: item.uid,
                  hash: this.positioning_guide_hash,
                },
              }).then((res) => {
                if (res.data) {
                  if (res.data.DeletePositioningGuide.status === 'Ok') {
                    this.$store.commit('CloseAlert', 'Item has been deleted!')
                    this.positioning_guides = res.data.DeletePositioningGuide.data
                    this.positioning_guide_hash = res.data.DeletePositioningGuide.hash
                  } else if (res.data.DeletePositioningGuide.status === '0') {
                    this.CheckError({ message: 'Session expired!' })
                  } else {
                    this.$store.commit('ShowError', res.data.DeletePositioningGuide.status)
                  }
                }
              }).catch(error => {
                this.CheckError(error)
              })
            }
          })
      },
      GetStoreBusinessExtensions () {
        this.loading_business_extensions = true
        this.business_extensions = []
        this.skip_business_extensions = false
        this.$apollo.queries.GetStoreBusinessExtensions.refetch()
      },
      GetDayParts () {
        this.loading_dayparts = true
        this.dayparts = []
        this.skip_dayparts = false
        this.$apollo.queries.GetDayParts.refetch()
      },
      GetDayPartList (f) {
        if (f === '') return
        if (f === this.business_extension_filter) return
        if (this.positioning_guide_id > 0) return // edit mode
        this.business_extension_filter = f
        this.daypart_name = ''
        this.daypart_list = []
        this.skip_daypart_list = false
        this.$apollo.queries.GetDayPartList.refetch()
      },
      GetPositioningGuides () {
        this.loading_positioning_guides = true
        this.positioning_guides = []
        this.skip_positioning_guides = false
        this.$apollo.queries.GetPositioningGuides.refetch()
      },
      SaveBusinessExtension () {
        if (!this.access.includes(this.roles.settings_update)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.$store.commit('Notify', '')
        if ((this.desert_center_count < 1) || (this.desert_center_count > 5)) {
          this.$store.commit('ShowError', 'Invalid Desert Center count!')
          return
        }
        this.$apollo.mutate({
          mutation: UpdateStoreBusinessExtension,
          variables: {
            business_extension: this.store_business_extensions.length === 0 ? '' : this.store_business_extensions.join(),
            desert_center_count: this.desert_center_count,
          },
        }).then((res) => {
          if (res.data.UpdateStoreBusinessExtension.status === 'Ok') {
            this.$store.commit('CloseAlert', '')
            this.GetDayParts()
            this.GetPositioningGuides()
          } else if (res.data.UpdateStoreBusinessExtension.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.UpdateStoreBusinessExtension.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
    },
    apollo: {
      GetStoreBusinessExtensions: {
        error (error) {
          this.loading_business_extensions = false
          this.CheckError(error)
        },
        query: GetStoreBusinessExtensions,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_business_extensions
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetStoreBusinessExtensions.status === 'Ok') {
              this.business_extensions = data.GetStoreBusinessExtensions.business_extension
              this.store_business_extensions = data.GetStoreBusinessExtensions.store_business_extension.business_extension.split(',')
              this.desert_center_count = data.GetStoreBusinessExtensions.store_business_extension.desert_center_count
              this.store_name = data.GetStoreBusinessExtensions.store_name
            } else if (data.GetStoreBusinessExtensions.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            }
            this.loading_business_extensions = false
            this.skip_business_extensions = true
          }
        },
      },
      GetDayParts: {
        error (error) {
          this.loading_dayparts = false
          this.CheckError(error)
        },
        query: GetDayParts,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_dayparts
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetDayParts) {
              this.dayparts = data.GetDayParts.data
              this.daypart_hash = data.GetDayParts.hash
              this.loading_dayparts = false
              this.skip_dayparts = true
            }
          }
        },
      },
      GetDayPartList: {
        error (error) {
          this.loading_daypart_list = false
          this.CheckError(error)
        },
        query: GetDayPartList,
        variables () {
          return {
            business_extension_filter: this.business_extension_filter,
          }
        },
        skip () {
          return this.skip_daypart_list
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetDayPartList) {
              this.daypart_list = data.GetDayPartList
              this.loading_daypart_list = false
              this.skip_daypart_list = true
            }
          }
        },
      },
      GetPositioningGuides: {
        error (error) {
          this.loading_positioning_guides = false
          this.CheckError(error)
        },
        query: GetPositioningGuides,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_positioning_guides
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetPositioningGuides) {
              this.positioning_guides = data.GetPositioningGuides.data
              this.positioning_guide_hash = data.GetPositioningGuides.hash
              this.loading_positioning_guides = false
              this.skip_positioning_guides = true
            }
          }
        },
      },
    },
  }
</script>
